var _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 64 64",
    id: "fill",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#502a7a",
    stroke: "#502a7a",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,24A21,21,0,1,0,24,43.413V50H40V43.413A21,21,0,0,0,53,24Z",
    style: {
      fill: "#Fbe4d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.439,4.778a20.982,20.982,0,0,1-22.906,34.43A21.006,21.006,0,0,0,24,43.413V50H40V43.413a20.992,20.992,0,0,0,.439-38.635Z",
    style: {
      fill: "#f2edeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,54v3a4,4,0,0,0,4,4h6a4,4,0,0,0,4-4V54Z",
    style: {
      fill: "#ff0080f0080"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 8,
    style: {
      fill: "#cceaff"
    },
    width: 16,
    x: 24,
    y: 49
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.284,21.8c-.215-.518-.365-.88-.579-1.4l.544-2.12-1.534-1.534L35.6,17.3l-1.4-.579-1.113-1.882h-2.17L29.8,16.716l-1.4.579-2.12-.544-1.534,1.534.544,2.12-.579,1.4-1.882,1.113v2.17L24.716,26.2c.215.518.365.88.579,1.4l-.544,2.12,1.534,1.534,2.12-.544c.518.214,1.077,1.08,1.595,1.3V49h4V32c.518-.215,1.077-1.081,1.595-1.3l2.12.544,1.534-1.534-.544-2.12.579-1.4,1.882-1.113v-2.17ZM32,27a3,3,0,1,1,3-3A3,3,0,0,1,32,27Z",
    style: {
      fill: "#ff0080"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38 49 38 52 24 52 24 54 38 54 38 57 40 57 40 49 38 49",
    style: {
      fill: "#85b4e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23 12 25 10 23 10 23 8 21 10 19 10 19 12 17 14 19 14 19 16 21 14 23 14 23 12",
    style: {
      fill: "#ff0080f0080ff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,2a22,22,0,0,0-9,42.072V57a1,1,0,0,0,1,1h.1A5.009,5.009,0,0,0,29,62h6a5.009,5.009,0,0,0,4.9-4H40a1,1,0,0,0,1-1V44.072A22,22,0,0,0,32,2Zm7,54H25V54H37V52H25V50H39Zm-4,4H29a3,3,0,0,1-2.816-2H37.816A3,3,0,0,1,35,60Zm4.618-17.511a1,1,0,0,0-.618.925V48H25V43.414a1,1,0,0,0-.618-.925,20,20,0,1,1,15.236,0Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.81b0795250f0a8916709c20c6e93e2cb.svg";
export { ForwardRef as ReactComponent };